;(function ($) {

	$(document).ready(function(){

		var map = null;

		$('.google-map').each(function(){

		    map = new_map( $(this) );

		});

	});


	$(window).load(function(){
		contactGallery();
		
		if ($(window).width() < 768) {

   			$('.contact-swipe').fadeToggle('slow');
		}		
		
	});


	$(window).resize(function(){
		
	});

	$(window).scroll(function() {
		
	});

	function contactGallery(){


		$('.contact-image-section').slick({
			dots: true,
			arrows:true,
			nextArrow: '<i class="fa fa-angle-right" aria-hidden="true"></i>',
			prevArrow: '<i class="fa fa-angle-left" aria-hidden="true"></i>',
			infinite: true,
			autoplay: false,
			autoplaySpeed: 5000,
			speed: 1000,
			slidesToShow: 1,
			pauseOnHover: false,
			dotsClass: 'custom_paging',
			customPaging: function (slider, i) {
				return  '<h6><span class="active-number">0' + (i + 1) + '</span>' + ' / <span class=total-numbers>0' + slider.slideCount + '</span></h6>';
			},
			appendDots: jQuery('#contact-numbers'),
			responsive: [
			{
			  breakpoint: 480,
			  settings: {
				dots: true,
				arrows:true,
				autoplay: false,
				autoplaySpeed: 5000,
				slidesToShow: 1,
				slidesToScroll: 1
			  }
			}]
		});

	}

	function new_map( $el ) {

	    var $markers = $el.find('.marker');

	    var args = {
	        zoom        : 16,
	        center      : new google.maps.LatLng(0, 0),
	        mapTypeId   : google.maps.MapTypeId.ROADMAP,
	        styles: [
	        {
	                "featureType": "all",
	                "elementType": "labels.text.fill",
	                "stylers": [
	                    {
	                        "saturation": 36
	                    },
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 40
	                    }
	                ]
	            },
	            {
	                "featureType": "all",
	                "elementType": "labels.text.stroke",
	                "stylers": [
	                    {
	                        "visibility": "on"
	                    },
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 16
	                    }
	                ]
	            },
	            {
	                "featureType": "all",
	                "elementType": "labels.icon",
	                "stylers": [
	                    {
	                        "visibility": "off"
	                    }
	                ]
	            },
	            {
	                "featureType": "administrative",
	                "elementType": "geometry.fill",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 20
	                    }
	                ]
	            },
	            {
	                "featureType": "administrative",
	                "elementType": "geometry.stroke",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 17
	                    },
	                    {
	                        "weight": 1.2
	                    }
	                ]
	            },
	            {
	                "featureType": "landscape",
	                "elementType": "geometry",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 20
	                    }
	                ]
	            },
	            {
	                "featureType": "poi",
	                "elementType": "geometry",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 21
	                    }
	                ]
	            },
	            {
	                "featureType": "road.highway",
	                "elementType": "geometry.fill",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 17
	                    }
	                ]
	            },
	            {
	                "featureType": "road.highway",
	                "elementType": "geometry.stroke",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 29
	                    },
	                    {
	                        "weight": 0.2
	                    }
	                ]
	            },
	            {
	                "featureType": "road.arterial",
	                "elementType": "geometry",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 18
	                    }
	                ]
	            },
	            {
	                "featureType": "road.local",
	                "elementType": "geometry",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 16
	                    }
	                ]
	            },
	            {
	                "featureType": "transit",
	                "elementType": "geometry",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 19
	                    }
	                ]
	            },
	            {
	                "featureType": "water",
	                "elementType": "geometry",
	                "stylers": [
	                    {
	                        "color": "#000000"
	                    },
	                    {
	                        "lightness": 17
	                    }
	                ]
	            }
	        ]
	     	//source: https://snazzymaps.com/style/38/shades-of-grey
	    };

	    var map = new google.maps.Map( $el[0], args);

	    map.markers = [];

	    $markers.each(function(){

	        add_marker( $(this), map );

	    });

	    center_map( map );

	    return map;

	}

	function add_marker( $marker, map ) {

	    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

	    var marker = new google.maps.Marker({
	        position    : latlng,
	        map         : map,
	        icon    : '/wp-content/themes/brandjuice/assets/images/pentagon-icon.png'

	    });


	    map.markers.push( marker );

	    if( $marker.html() ){
	        var infowindow = new google.maps.InfoWindow({
	            content     : $marker.html()
	        });
	        google.maps.event.addListener(marker, 'click', function() {

	            infowindow.open( map, marker );

	        });
	    }

	}

	function center_map( map ) {



	    var bounds = new google.maps.LatLngBounds();

	    $.each( map.markers, function( i, marker ){
	        var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
	        bounds.extend( latlng );

	    });

	    if( map.markers.length == 1 ){

	        map.setCenter( bounds.getCenter() );
	        map.setZoom( 16 );
	    } else {

	        map.fitBounds( bounds );
	    }

	}	


})(jQuery);